<!-- ----------------------------------------------- -->
<template>
  <v-card class="tm-mb-cctv-card tm-mb-no-shadow">
    <div class="tm-mb-cctv-card-warp">
      <v-card v-if="showDialog" class="vc-dialog-content mt-0 px-4">
        <v-card class="vc-dialog-card">
          <div class="vc-dialog-header pl-4">
            <span class="vc-dialog-title">履歴動画再生不可</span>
          </div>
          <div class="vc-dialog-box vc-dialog-box-confirm pl-4">
            過去画像が不足しているため、表示できません。
          </div>
          <div class="vc-dialog-box pb-4 pr-4">
            <v-spacer></v-spacer>
            <v-btn outlined small color="success" class="mt-0 ml-4" @click="closeDialog()">
              <v-icon left>clear</v-icon>
              閉じる
            </v-btn>
          </div>
        </v-card>
      </v-card>
      <div class="pt-2">
        <template v-if="hasLatestUrl">
          <v-btn
            v-if="isCurrent"
            depressed
            class="tm-mb-btn-live"
            :class="{ 'btn-on': selectCamera === 'live' }"
            @click="selectCamera = 'live'"
            >{{ text.live.label }}</v-btn
          >
          <v-btn
            v-if="!isCurrent"
            class="tm-mb-btn-live"
            :class="{ 'btn-on': selectCamera === 'live' }"
            @click="selectCamera = 'live'"
            depressed
            >{{ text.history.label }}</v-btn
          >
        </template>
        <v-btn
          v-if="hasUsualUrl"
          class="tm-mb-btn-normal"
          :class="{ 'btn-on': selectCamera === 'normal' }"
          @click="selectCamera = 'normal'"
          depressed
          >{{ text.normal.label }}</v-btn
        >
      </div>
      <div>
        <!-- 観測設定時 -->
        <div v-if="selectCamera === 'live' && hasLatestUrl" class="px-2">
          <div v-if="!historyImageMovieFlg">
            <v-img
              :src="latestUrl"
              class="tm-mb-rv-cam-now-img"
              :alt="isCurrent ? text.live.alt : text.history.alt"
              @error="liveImgError = true"
            >
              <template v-slot:placeholder>
                <v-sheet class="tm-mb-progress-content">
                  <v-progress-circular
                    v-slot:placeholder
                    v-if="!liveImgError"
                    indeterminate
                    class="tm-mb-progress-img"
                  ></v-progress-circular>
                </v-sheet>
              </template>
            </v-img>
          </div>
          <div v-else-if="historyImageMovieFlg">
            <v-sheet v-if="imageLoading" class="tm-pc-progress-content">
              <v-progress-circular
                indeterminate
                class="tm-mb-progress-img"
              ></v-progress-circular>
            </v-sheet>
            <img
              v-else
              :src="sliderImages[currentIndex]"
              loading="eager"
              :alt="isCurrent ? text.live.alt : text.history.alt"
              @error="liveImgError = true"
              class="tm-mb-rv-cam-now-img"
            />
          </div>
        </div>
        <!-- 平常時 -->
        <div v-if="selectCamera === 'normal' && hasUsualUrl">
          <v-img
            :src="usualUrl"
            class="tm-mb-rv-cam-nomal-img"
            :alt="text.normal.alt"
            @error="normalImgError = true"
          >
            <template v-slot:placeholder>
              <v-sheet class="tm-mb-progress-content">
                <v-progress-circular
                  v-slot:placeholder
                  v-if="!normalImgError"
                  indeterminate
                  class="tm-mb-progress-img"
                ></v-progress-circular>
              </v-sheet>
            </template>
          </v-img>
        </div>
      </div>
      <!-- slider -->
      <template v-if="!isReduction && hasLatestUrl && selectCamera === 'live'">
        <template class="com-mb-card-contents">
          <v-row justify="center" class="no-gutters pt-3">
            <v-btn
              v-show="isNotPlayMb"
              rounded
              depressed
              outlined
              color="success"
              @click="readyEnlargeHistoryImages()"
              :disabled="sliderMissingImages"
            >
              <v-icon left color="success">play_arrow</v-icon>
              <span>{{ text.play }}</span>
            </v-btn>
            <v-btn
              v-show="isReadyMb"
              rounded
              depressed
              outlined
              loading
              color="success"
            >
              <v-icon left color="success">play_arrow</v-icon>
              <span>{{ text.play }}</span>
            </v-btn>
            <v-btn
              v-show="isPlayMb"
              rounded
              depressed
              outlined
              color="success"
              @click="stopPlay()"
            >
              <v-icon left color="red">pause</v-icon>
              <span class="red--text">{{ text.stop }}</span>
            </v-btn>
          </v-row>
          <v-row justify="center" class="no-gutters pl-4 pr-4">
            <v-slider
              v-model="currentIndex"
              @input="handleSlideChange"
              tick-size="0"
              :thumb-color="sliderThumbColor"
              :tick-labels="sliderLabelTime"
              :max="arrayHistoryImages.length === 0 ? 1 : arrayHistoryImages.length - 1"
              min="0"
              step="1"
              :disabled="isSliderDisable"
            >
              <template v-slot:prepend>
                <v-icon
                  :color="isSliderDisable ? 'disable' : 'success'"
                  @click="fastRewind('arrow')"
                  >fast_rewind</v-icon
                >
              </template>
              <template v-slot:append>
                <v-icon
                  :color="isSliderDisable ? 'disable' : 'success'"
                  @click="fastForward('arrow')"
                  >fast_forward</v-icon
                >
              </template>
            </v-slider>
          </v-row>
        </template>  
        <v-col>{{ text.tmScamSliderNote }}</v-col>
      </template>
    </div>
  </v-card>
</template>
<!-- ----------------------------------------------- -->
<script>
/**
 * 川の防災情報 [MB]簡易カメラカード
 * TmScam.vue
 * @author ILUKE
 */
import mixin from "./../../lib/mixin.js";
import tmObs from "./../../lib/tmObs.js";
import PageLog from "./../../lib/pageLog.js";
import { setInterval, clearInterval } from "timers";

export default {
  mixins: [mixin],
  name: "tm-scam",
  props: {
    isDlg: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      /** 画像取得エラー */
      liveImgError: false,
      normalImgError: false,
      latestUrl: "",
      cameraId: "",
      /** スライダー関連 */
      showDialog: false,
      sliderImages: [],
      imageLoading: true,
      intervalId: null,
      intervalTime: 1000,
      /** 文字列リソース */
      text: {
        // 現在(LIVE)
        live: {
          label: "現在",
          alt: "最新時画像",
        },
        // 過去
        history: {
          label: "過去",
          alt: "過去画像",
        },
        // 平常時
        normal: {
          label: "平常時",
          alt: "平常時画像",
        },
        // 過去画像動画関連
        play: "再生",
        stop: "停止",
        tmScamSliderNote: "上の再生ボタンを押すと、直前の１~２時間のカメラ画像をコマ送り表示できます。表示間隔は５分ですが、過去画像がない場合はその時刻をスキップします。"
      },
    };
  },
  created() {
    this.$log.debug("[TmScam] created()");
    if (!this.isDlg) {
      if (this.hasLatestUrl) {
        this.selectCamera = "live";
      } else {
        this.selectCamera = "normal";
      }
    }

    if (this.hasUsualUrl) {
      this.usualUrl = this.tmScam.usualUrl;
    }

    if (this.isStopMb) {
      this.$store.commit("Telemeter/setAppTimeControlFlg", true);
    }
  },
  mounted() {
    this.$log.debug("[TmScam] mounted()");
    this.getPostCamera();
    /** 
     * カメラ画像表示
     * @property {boolean} this.isCurrent 観測日時 現在/過去フラグ
     * @property {string} this.$store.state.Telemeter.historyPrintCurrentPicture 過去画像の有無 
     * @property {boolean} this.historyImageMovieFlg 履歴動画再生フラグ
     */
    if (!this.isCurrent && !this.historyImageMovieFlg && this.$store.state.Telemeter.historyPrintCurrentPicture) {
      this.latestUrl = this.historyPrintCurrentPicture;
    } else if (this.isCurrent && !this.historyImageMovieFlg && this.hasLatestUrl) {
      this.latestUrl = this.tmScam.latestUrl;
    } else if (this.historyImageMovieFlg) {
      this.changeToEnlargeSetImages();
    }
    this.refreshImage();
  },
  beforeDestroy() {
    this.$log.debug("[TmScam] beforeDestroy()");
    this.$store.commit("Telemeter/setEnlargedView", false);
    if (this.historyImageMovieFlg) {
      this.$store.commit('Telemeter/setMovieCurrentIndex',this.currentIndex);
      this.$store.commit("Telemeter/syncBackStatus");
      if (this.intervalId) {
        clearInterval(this.intervalId);
        this.intervalId = null;
      }
      this.$store.commit("sns/setPrintCurrentPicture", this.arrayHistoryImages[this.currentIndex]);
    }
  },
  computed: {
    /**
     * 簡易カメラ情報 取得
     */
    tmScam: {
      get() {
        return this.$store.state.Telemeter.selectedTm.scamInfo;
      },
    },
    hasLatestUrl: {
      get() {
        return tmObs.hasLatestUrl(this.tmScam);
      },
    },
    hasUsualUrl: {
      get() {
        return tmObs.hasUsualUrl(this.tmScam);
      },
    },
    /** 選択中河川カメラ画像 取得 */
    selectCamera: {
      get() {
        return this.$store.state.Telemeter.selectCamera;
      },
      set(val) {
        this.$store.commit("Telemeter/setSelectCamera", val);
      },
    },
    /** 簡易版の判定 */
    isReduction: {
      get() {
        return global.KWB_MODE == "reduction";
      },
    },
    /** 観測日時 */
    appTime: {
      get() {
        return this.$store.state.app.appTime;
      },
    },
    /**
     * 観測日時更新フラグ
     */
    isCurrent: {
      get() {
        return this.$store.state.app.isCurrent;
      },
    },
    /* 過去画像 */
    historyPrintCurrentPicture: {
      get() {
        return this.$store.state.Telemeter.historyPrintCurrentPicture;
      },
    },
    /** 再生状態 */
    playStatus: {
      get() {
        return this.$store.state.Telemeter.historyImageSlider.enlargeHistoryPlayStatus;
      },
      set(val) {
        this.$store.commit("Telemeter/setEnlargeHistoryPlayStatus", val);
      },
    },
    appTimeControlFlg: {
      get() {
        return this.$store.state.Telemeter.historyImageSlider.appTimeControlFlg;
      },
      set(val) {
        this.$store.commit("Telemeter/setAppTimeControlFlg", val);
      },
    },
    /* 過去画像不足フラグ */
    sliderMissingImages: {
      get() {
        return this.$store.state.Telemeter.historyImageSlider.sliderMissingImages;
      },
      set(val) {
        this.$store.commit("Telemeter/setSliderMissingImages", val);
      },
    },
    /** 履歴再生中状態 */
    isPlayMb: {
      get() {
        return this.$store.getters["Telemeter/isPlayMb"];
      },
    },
    /** 履歴停止中以外状態 */
    isReadyMb: {
      get() {
        return this.$store.getters["Telemeter/isReadyMb"];
      },
    },
    /** 履歴停止中状態 */
    isStopMb: {
      get() {
        return this.$store.getters["Telemeter/isStopMb"];
      },
    },
    /** 履歴動画再生/準備中以外状態 */
    isNotPlayMb: {
      get() {
        return this.$store.getters["Telemeter/isNotPlayMb"];
      },
    },
    /** 履歴動画未再生状態 */
    isNoneMb: {
      get() {
        return this.$store.getters["Telemeter/isNoneMb"];
      },
    },
    /* 過去画像が格納された配列 */
    arrayHistoryImages: {
      get() {
        return this.$store.getters["Telemeter/arrayHistoryImages"];
      }
    },
    /* 取得した画像と同じ時間の配列(appTime用) */
    arrayHistoryAppTime: {
      get() {
        return this.$store.state.Telemeter.historyImageSlider.arrayHistoryAppTime;
      }
    },
    /* 取得した画像の詳細時間の配列(latestTime用) */
    detailTime() {
      return this.$store.state.Telemeter.historyImageSlider.detailTime;
    },
    /* 取得した画像と同じ時間の配列(スライダーラベル用) */
    sliderLabelTime() {
      return this.$store.state.Telemeter.historyImageSlider.sliderLabelTime;
    },
    /* スライダー有効判定 */
    isSliderDisable: {
      get() {
        return this.isDisable || this.isReadyMb || this.isNoneMb;
      },
    },
    /* スライダー色 */
    sliderThumbColor: {
      get() {
        let color = "success";
        if (this.isPlayMb) {
          color = "red";
        }
        if (this.isSliderDisable) {
          color = "disable";
        }
        return color;
      },
    },
    /* 過去画像再生ボタン押下フラグ */
    historyImageMovieFlg: {
      get() {
        return this.$store.state.Telemeter.historyImageSlider.historyImageMovieFlg;
      },
      set(val) {
        this.$store.commit("Telemeter/setHistoryImageMovieFlg", val);
      },
    },
    /* スライダーの現在位置 */
    currentIndex: {
      get() {
        return this.$store.getters["Telemeter/enlargedMovieCurrentIndex"];
      },
      set(valIndex) {
        this.$store.commit("Telemeter/setEnlargedMovieCurrentIndex", valIndex);
      },
    },
    isEnlarged() {
      return this.$store.state.Telemeter.historyImageSlider.isEnlargeView;
    },
    camSlidData: {
      get() {
        return this.$store.state.app.config.tmObsConfig.scam;
      },
    },
    originProduction: {
      get() {
        return this.$store.state.app.config.originProduction;
      },
    },
    historyCamUrl: {
      get() {
        return this.$store.state.app.config.tmObsConfig.historyCamUrl;
      },
    },
    testEnvironmentsIp: {
      get() {
        return this.$store.state.app.config.testEnvironmentsIp;
      },
    }
  },
  methods: {
    getPostCamera() {
      this.$log.debug("[TmScam] getPostCamera()");
      this.$store.dispatch("sns/getPostCamera", { camera: this.selectCamera });
    },
    refreshImage() {
      if (this.hasUsualUrl) {
        URL.revokeObjectURL(this.usualUrl);
      }
      if (this.hasLatestUrl) {
        URL.revokeObjectURL(this.latestUrl);
      }
    },
    getSelectedObsData() {
      const appTime = this.isCurrent ? new Date(this.$store.state.Telemeter.historyImageSlider.movieEndTime) : new Date(this.appTime);
      const currProvUrl = this.$store.state.Telemeter.selectedTm.scamInfo.latestUrl;
      this.cameraId = tmObs.extractImageName(currProvUrl);
      const itmkndCd = this.$store.state.Telemeter.selectedTmParam.itmkndCd;
      // カメラ種別 (過去画像取得時間簡易カメラ5分、河川カメラ10分出し分け用)
      const sysId = this.$store.state.Telemeter.selectedTm.scamInfo.sysId;

      return {
        appTime: appTime,
        cameraId: this.cameraId,
        itmkndCd: itmkndCd,
        sysId: sysId,
      }
    },
    readyEnlargeHistoryImages() {
      this.$log.debug("[TmScam] readyEnlargeHistoryImages()");
      // アクセスログ出力
      PageLog.log({
        page_log: "scam_movie",
        zm: this.$store.state.map.zoom,
        cam_cd: this.$store.state.Telemeter.selectedTmParam.scamId,
        cam_sb: "scam",
        device_sb: this.$store.state.app.mode,
        fc_flg: this.$store.getters["app/isFldCtl"],
      });

      // 停止または再再生時
      if (this.isPlayMb) {
        this.playStatus = "stop";
        return;
      } else if (this.isStopMb) {
        this.playStatus = "play";
        return;
      }

      this.addCurrentTmQueryTime();
      // 初回再生
      this.playStatus = "readyMovie";
      this.$store.dispatch("Telemeter/obsAppTimeArray", [this.getSelectedObsData(), this.camSlidData, this.originProduction, this.historyCamUrl, this.testEnvironmentsIp]);
    },
    addCurrentTmQueryTime() {
      if (this.isCurrent) {
        this.$store.commit("Telemeter/setMovieEndTime", tmObs.getBaseTime(this.appTime, this.isCurrent, this.$store.state.radar.radarType, this.$store.state.radar.radarXrainDate, this.$store.state.radar.radarCbandDate));
        this.replaceTmQuery("currentTime");
      }
    },
    fastForward(type) {
      this.$log.debug("[TmScam] fastForward()");
      if (this.currentIndex < this.arrayHistoryImages.length - 1) {
        this.currentIndex++;
        if (this.isPlayMb || this.isStopMb) {
            this.$store.commit("Telemeter/setLatestScamTime", this.detailTime[this.currentIndex]);
          if (type === "arrow") {
            this.$store.commit("Telemeter/setAppTimeControlFlg", true);
            this.$store.commit("app/setTime", this.arrayHistoryAppTime[this.currentIndex]);
          } else {
            this.$store.commit("app/setTime", this.arrayHistoryAppTime[this.currentIndex]);
          }
        }
      } else {
        this.stopPlay();
      }
    },
    fastRewind(type) {
      this.$log.debug("[TmScam] fastRewind()");
      if (this.currentIndex > 0) {
        this.currentIndex--;
        if (this.isPlayMb || this.isStopMb) {
          this.$store.commit("Telemeter/setLatestScamTime", this.detailTime[this.currentIndex]);
          if (type === "arrow") {
            this.$store.commit("Telemeter/setAppTimeControlFlg", true);
            this.$store.commit("app/setTime", this.arrayHistoryAppTime[this.currentIndex]);
          } else {
            this.$store.commit("app/setTime", this.arrayHistoryAppTime[this.currentIndex]);
          }
        }
      } else {
        this.currentIndex = 0;
      }
    },
    handleSlideChange(index) {
      this.$log.debug("[TmScam] handleSlideChange()");
      // 画面表示時、@inputが意図せず、-1を返してしまうため早期リターン
      if (index === -1) {
        return
      }
      this.appTimeControlFlg = false;
      this.currentIndex = index;
      if (this.isPlayMb || this.isStopMb) {
        this.$store.commit("Telemeter/setLatestScamTime", this.detailTime[this.currentIndex]);
        if (!this.appTimeControlFlg) {
          this.$store.commit("Telemeter/setAppTimeControlFlg", true);
          this.$store.commit("app/setTime", this.arrayHistoryAppTime[this.currentIndex]);
        }
      }
    },
    /** 再生 */
    startAutoPlay() {
      this.$log.debug("[TmScam] startAutoPlay()");
      this.$store.commit("Telemeter/setHistoryImageMovieFlg", true);
      this.playStatus = "play";
      if (this.intervalId) {
        clearInterval(this.intervalId);
      }
      this.intervalId = setInterval(() => {
        this.fastForward();
      }, this.intervalTime);
    },
    /** 停止 */
    stopPlay() {
      this.$log.debug("[TmScam] stopPlay()");
      this.playStatus = "stop";
      if (this.intervalId) {
        clearInterval(this.intervalId);
        this.intervalId = null;
      }
    },
    resetLocalIndex() {
      this.currentIndex = 0;
      this.$store.commit("app/setTime", this.arrayHistoryAppTime[0]);
      this.startAutoPlay();
    },
    setHistoryImages() {
      this.sliderImages = this.arrayHistoryImages;
      this.imageLoading = false;
      if (!this.historyImageMovieFlg) {
        this.$store.commit("Telemeter/setHistoryImageMovieFlg", true);
        this.playStatus =  "play";
        return;
      } else if (this.isPlayMb) {
        this.playStatus =  "stop";
        return;
      } else if (this.isStopMb) {
        this.playStatus =  "play";
      }
    },
    /** 通常画面から拡大画面切り替え時画像セット */
    changeToEnlargeSetImages() {
      this.sliderImages = this.arrayHistoryImages;
      this.imageLoading = false;
      if (this.isStopMb) {
        this.$store.commit("Telemeter/setAppTimeControlFlg", true);
        this.stopPlay();
      } else if (this.isPlayMb) {
        this.startAutoPlay();
      }
    },
    closeDialog() {
      this.showDialog = false;
      this.$store.commit("Telemeter/setSliderMissingImages", true);
      this.$store.commit("Telemeter/setHistoryImageMovieFlg", false);
    },
  },
  watch: {
    selectCamera() {
      this.$log.debug("[rp]watch - getPostCamera()");
      this.getPostCamera();
      if (this.historyImageMovieFlg && this.isPlayMb && this.selectCamera === "normal") {
        this.stopPlay();
      }
    },
    // カメラ情報取得 監視
    tmScam() {
      this.$log.debug("[TmScam]watch - tmScam");
      if (this.hasLatestUrl) {
        this.selectCamera = "live";
      } else {
        this.selectCamera = "normal";
      }
    },
    appTime() {
      this.$log.debug("[TmScam]watch - appTime");
      // 選択中観測所 過去画像動画再生処理中による観測日時更新時は画面更新させない
      if (this.isPlayMb || this.appTimeControlFlg) {
        this.$store.commit("Telemeter/setAppTimeControlFlg", false);
      } else {
        this.loadTmObs();
        // 過去画像動画状態をリセット
        this.$store.commit("Telemeter/resetHistoryPlay");
        this.$store.commit("Telemeter/resetHistoryPrintCurrentPicture");
      }
    },
    arrayHistoryImages(array) {
      this.$log.debug("[TmScam]watch - arrayHistoryImages");
      if (!this.isEnlarged) {
        return
      }

      if (this.isReadyMb && array.length >= 4) {
        this.setHistoryImages();
      }
    },
    playStatus(status) {
      this.$log.debug("[TmScam]watch - playStatus");
      if (!this.historyImageMovieFlg && !this.sliderImages.length || !this.isEnlarged) {
        return;
      }

      if (this.historyImageMovieFlg && this.currentIndex === this.arrayHistoryImages.length -1 && status === "play") {
        this.resetLocalIndex();
      } else if (0 < this.currentIndex < this.arrayHistoryImages.length -1 && status === "play") {
        this.$store.commit("app/setTime", this.arrayHistoryAppTime[this.currentIndex]);
        this.startAutoPlay();
      } else if (status === "stop") {
        this.stopPlay();
      }
    },
    sliderMissingImages(flg) {
      this.$log.debug("[TmScam]watch - sliderMissingImages");
      if (flg) {
        this.showDialog = true;
        this.currentIndex = 0;
        this.playStatus = "none";
        this.replaceTmQuery();
      }
    },
  },
};
</script>
<!-- ----------------------------------------------- -->
<style lang="scss" scoped>
@import "./../../scss/color.scss";

.tm-mb-cctv-card-warp {
  position: relative;
  width: 100%;
}

.vc-dialog-content {
  position: absolute;
  background-color: rgba(lightgray, 0.8);
  // opacity: 0.8;
  z-index: 3030;
  width: 100%;
  height: 100%;

  .vc-dialog-card {
    max-width: 600px;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
      
    .vc-header {
      display: flex;
    }
    .vc-dialog-header {
      background-color: $color-header-back;
      color: $color-header-text;
      line-height: 40px;
      height: 40px;
      width: 100%;
    }
    .vc-dialog-box {
      display: flex;
      flex-direction: row;
      align-items: flex-start;
      width: 100%;
      .vc-dialog-box-confirm {
        font-size: 1rem;
      }
    }
  }
}
</style>
